export default "/ui/images/block-vector-desktop.svg";